import { VNode, VNodeChildren, h, defineComponent, SetupContext } from 'vue';
import { NamedLocation, RouteName } from '@/ui/routes/types';
import { filterEmptyQueryValues, Query } from '@/ui/routes/query';

export interface NamedLinkProps {
  name: RouteName;
  id?: string;
  query?: Query;
}

export const NamedLink = defineComponent<NamedLinkProps>({
  name: 'NamedLink',
  props: ['name', 'id', 'query'],
  setup(props, context: SetupContext) {
    return function render(): VNode {
      const to: NamedLocation = {
        name: props.name,
        query: props.query !== undefined
          ? filterEmptyQueryValues(props.query)
          : undefined,
      };
      if (props.id) {
        to.params = { id: props.id };
      }
      return h('router-link', { props: { to } }, context.slots.default && context.slots.default());
    };
  },
});

export const namedLink = <T = Query>(
  anchor: VNodeChildren,
  name: RouteName,
  id?: string,
  query?: T,
) => h(
  NamedLink,
  {
    props: {
      name,
      id,
      query,
    },
  },
  anchor,
);
